///
/// EarthBrowser
///
/// Created by Matt Giger on 9/24/2026
/// Copyright (c) 2026 Geodata Labs
///
/// CSS display constants for storms, shared by the React info panel, the
/// hurricane browser, and the embed target HUD so the intensity ramp and
/// NHC watch/warning palette can't drift between surfaces. Mirrors the
/// engine-side DesignColors.STORM_CATEGORY / STORM_TROPICAL_STORM /
/// STORM_WW_* colors (those are rgba engine values, these are CSS hex).
///

import { type StormTrackPoint } from "@/earthbrowser/dataset-distribution/hurricanes/HurricanesTable"

/** Standard hurricane-tracker intensity ramp: index 0 = TD, 1-5 = Cat 1-5 */
export const cStormCategoryHex = ["#5ebaff", "#ffffcc", "#ffe775", "#ffc140", "#ff8f20", "#ff6060"]

/** Tropical storm (34-63 kt, below hurricane strength) */
export const cTropicalStormHex = "#00faf4"

/** Intensity color for a storm or track point */
export function stormCategoryHex(category: number, windKt: number | null): string {
	if (category >= 1) return cStormCategoryHex[Math.min(category, 5)]
	return (windKt ?? 0) >= 34 ? cTropicalStormHex : cStormCategoryHex[0]
}

/** NHC watch/warning palette by TCWW code */
export const cWatchWarningStyle: Record<string, { label: string, hex: string }> = {
	HWR: { label: "Hurricane Warning", hex: "#e01c24" },
	HWA: { label: "Hurricane Watch", hex: "#ff6bb5" },
	TWR: { label: "T.S. Warning", hex: "#4078ff" },
	TWA: { label: "T.S. Watch", hex: "#ffd64f" },
}

/** Short label for a track point ("Cat 3" / "TS" / "TD") */
export function pointCategoryLabel(point: StormTrackPoint): string {
	if (point.category >= 1) return `Cat ${point.category}`
	return (point.wind_kt ?? 0) >= 34 ? "TS" : "TD"
}
